import { Component, OnInit } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthenticationService } from 'apps/driver-dashboardfe/src/app/core/services/authentication/authentication.service';
import { DialogHandlerService } from 'apps/driver-dashboardfe/src/app/core/services/dialog-handler/dialog-handler.service';
import { JoinService } from 'apps/driver-dashboardfe/src/app/core/services/join/join.service';
import { pattern } from 'apps/driver-dashboardfe/src/app/shared/constants/pattern.constant';
import { MatchValidator } from 'apps/driver-dashboardfe/src/app/shared/validators/mustMatch.validator';
import {
    startUserSessionMonitor,
    resetUserToken,
} from '../../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    user: any = {};
    resetPasswordForm = new UntypedFormGroup({});
    resetEmailForm = new UntypedFormGroup({});
    userEmail: string = '';
    isResetWithToken: boolean = false;
    showPassword: boolean = false;
    showConfirmPassword: boolean = false;
    resetFormSubmitted: boolean = false;
    resetTokenFormSubmitted: boolean = false;
    token: any;
    paramEmail: any;

    constructor(
        private route: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private router: Router,
        private authService: AuthenticationService,
        private joinService: JoinService,
        private dialogService: DialogHandlerService
    ) {}

    ngOnInit(): void {
        resetUserToken();
        startUserSessionMonitor();

        this.route.queryParams.subscribe((params) => {
            this.paramEmail = params['email'];
        });

        this.route.params.subscribe((params: Params) => {
            if (params['token']) {
                let decodedJwt: any = this.authService.decodeToken(
                    params['token']
                );
                this.token = params['token'];
                this.isResetWithToken = true;
                this.userEmail = decodedJwt.email;
                this.initResetForm();
            } else {
                this.isResetWithToken = false;
                this.resetEmailForm = new UntypedFormGroup({
                    email: new UntypedFormControl('', [
                        Validators.required,
                        Validators.pattern(pattern.email),
                    ]),
                });
                this.resetEmailForm.get('email')?.setValue(this.paramEmail);
            }
        });
    }

    initResetForm(): void {
        this.resetPasswordForm = this.fb.group(
            {
                email: this.userEmail,
                password: [
                    '',
                    [
                        Validators.required,
                        Validators.minLength(8),
                        Validators.maxLength(50),
                        Validators.pattern(pattern.password),
                    ],
                ],
                confirm_password: [
                    '',
                    [
                        Validators.required,
                        Validators.minLength(8),
                        Validators.maxLength(50),
                        Validators.pattern(pattern.password),
                    ],
                ],
            },
            {
                validators: MatchValidator('password', 'confirm_password'),
            }
        );
    }

    get resetForm() {
        return this.resetPasswordForm.controls;
    }

    onResetSubmit(): void {
        if (!this.resetPasswordForm.valid) return;

        this.resetTokenFormSubmitted = true;

        this.joinService
            .resetPassword({
                email: this.resetPasswordForm.value.email,
                password: this.resetPasswordForm.value.password,
                confirm_password: this.resetPasswordForm.value.confirm_password,
                token: this.token,
            })
            .subscribe({
                next: (data) => {
                    this.router.navigate(['/login']);
                    this.dialogService
                        .confirmAction(
                            {
                                title: 'Success!',
                                message:
                                    'Password successfully reset. Please log in.',
                            },
                            false
                        )
                        .subscribe((data) =>
                            window.scroll({
                                top: 0,
                                left: 0,
                                behavior: 'smooth',
                            })
                        );
                },
                error: (error: any) => {
                    if (error.status != 485) {
                        if (error?.status === 400) {
                            this.router.navigate(['/reset']);
                            this.dialogService
                                .confirmAction(
                                    {
                                        title: 'Oops!',
                                        message:
                                            error?.error?.message ||
                                            'Some communication error has occurred. Please try again later.',
                                    },
                                    false
                                )
                                .subscribe((data) =>
                                    window.scroll({
                                        top: 0,
                                        left: 0,
                                        behavior: 'smooth',
                                    })
                                );
                        } else {
                            this.dialogService.alert({
                                title: 'Oops!',
                                message:
                                    error?.error?.message ||
                                    'Some communication error has occurred. Please try again later.',
                            });
                        }
                    }
                },
            });
    }

    onSubmit(): void {
        this.resetFormSubmitted = true;
        if (!this.resetEmailForm.valid) return;
        this.joinService
            .forgotPassword({ ...this.resetEmailForm.value })
            .subscribe((data: any) => {
                this.router.navigate(['/login']);
                this.dialogService.openInfoDialog('reset');
            });
    }
}
